var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
function InputComponent(props, ref) {
    var onChange = props.onChange, id = props.id, type = props.type, form = props.form, rest = __rest(props, ["onChange", "id", "type", "form"]);
    var getType = function () {
        return type !== null && type !== void 0 ? type : 'text';
    };
    var handleInputChange = function (e) {
        onChange({
            id: id,
            value: e.target.value,
        });
    };
    return (_jsx("input", __assign({}, rest, { type: getType(), onChange: handleInputChange, value: form.values[props.id], onBlur: function () { return form.values[props.id] !== '' && form.config.setShowErrors([props.id], true); }, ref: ref })));
}
export var Input = React.forwardRef(InputComponent);
export default Input;
